import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BehaviorSubject, map, Observable} from "rxjs";
import he, {decode} from "he";

declare var $: any;

@Component({
  selector: 'app-multiselect-block',
  templateUrl: './multiselect-block.component.html',
  styleUrls: ['./multiselect-block.component.css', '../../common/styles/common.css']
})
export class MultiselectBlockComponent implements OnInit {
  @Input() initData!: {id: string, options?: object};
  @Input() status!: {message: string, classes: any[], isValid : boolean, isLoading : boolean};
  @Input() update$!: Observable<Map<string, boolean>>;
  @Output() onMultiselectClick = new EventEmitter<any>();
  protected values: Map<string, boolean> = new Map();
  @Input() sectionTitle: string = '';

  // observable

  ngOnInit() {

    this.update$.subscribe((map) => {
      const decodedMap = new Map<string, boolean>();
      for (const [key, value] of map.entries()) {
        decodedMap.set(decode(key), value);
      }
      this.values = decodedMap;
      this.updateMultiselect();
    });
    $(document).ready(() => {
          $('#'+this.initData.id)
              .multiselect(this.initData.options);
    });
  }

  private updateMultiselect() {
    let arr: Object[] = [];
    [...this.values.keys()].forEach(key => {
      arr.push({label: key, value: key, selected: !!this.values.get(key)})
    });
/*    $('#' + this.initData.id)
      .multiselect('dataprovider', arr)
      .multiselect('setOptions',
      {
        nonSelectedText: this.values.size,
      }
    );*/

    $('#' + this.initData.id)
        .multiselect('dataprovider', arr)
        .multiselect('setOptions', {nbPlacesToShow: " (" + this.values.size + ")"});
  }

  protected readonly Array = Array;
}
